import { render, staticRenderFns } from "./EditTint.vue?vue&type=template&id=d2b40678&"
import script from "./EditTint.vue?vue&type=script&lang=js&"
export * from "./EditTint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports